import { Box, Typography, Paper, alpha, useTheme } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";

type TStatBox = {
  name: string;
  sum: number;
  icon: SvgIconComponent;
  successPercent: number;
  providerPercent: number;
};

/** Подписи-расшифровки для метрик, у которых есть доля от общего трафика. */
const hints: Record<string, (p: number, s: number) => string | null> = {
  "Выдано реквизитов на сумму": (providerPercent) =>
    `${providerPercent}% от всего трафика`,
  "Всего обработано трафика": (_, successPercent) =>
    `${successPercent}% успешного от выданного`,
};

const StatBox: React.FC<TStatBox> = ({
  name,
  sum,
  icon: Icon,
  successPercent,
  providerPercent,
}) => {
  const theme = useTheme();
  const hint = hints[name]?.(providerPercent, successPercent) ?? null;

  return (
    <Paper
      sx={{
        borderRadius: "18px",
        minWidth: "221px",
        height: "150px",
        p: 2.25,
        overflow: "hidden",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        transition: "transform 180ms ease, border-color 180ms ease",
        "&:hover": {
          transform: "translateY(-3px)",
          borderColor: alpha(theme.palette.primary.main, 0.4),
        },
        "&::after": {
          content: '""',
          position: "absolute",
          width: 90,
          height: 90,
          right: -26,
          top: -34,
          borderRadius: "50%",
          backgroundColor: alpha(theme.palette.primary.main, 0.07),
          pointerEvents: "none",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 1.5,
        }}
      >
        <Typography
          color="text.secondary"
          sx={{ fontSize: 13, fontWeight: 620, lineHeight: 1.3 }}
        >
          {name}
        </Typography>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "12px",
            display: "grid",
            placeItems: "center",
            color: "primary.main",
            bgcolor: alpha(theme.palette.primary.main, 0.11),
            flexShrink: 0,
            zIndex: 1,
          }}
        >
          <Icon fontSize="small" />
        </Box>
      </Box>

      <Box>
        <Typography
          sx={{
            fontSize: 28,
            fontWeight: 740,
            letterSpacing: "-0.03em",
            lineHeight: 1.1,
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {sum.toLocaleString("ru-RU")}
        </Typography>
        {hint && (
          <Typography
            color="text.secondary"
            sx={{ fontSize: 12, mt: 0.25, fontWeight: 560 }}
          >
            {hint}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default StatBox;
